import React from "react";
import { SideIllustration } from "../components/common/SideIllustration";
import { IMAGE_SOURCES } from "../mock/imageSources";

export default function TeachersEducators() {
  return (
    <div className="space-y-8">
      <section className="space-y-4">
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900">Teachers &amp; Educators</h1>
        <p className="max-w-3xl text-sm leading-relaxed text-slate-700 sm:text-base">
          Teachers are central to the effectiveness of the certification process. Global Music Conservatory aims to work collaboratively with educators by providing clear syllabi, assessment criteria and feedback that can be integrated into everyday teaching.
        </p>
      </section>

      <section className="grid gap-6 rounded-2xl border border-slate-200 bg-white/80 p-5 shadow-sm backdrop-blur-xl md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] md:p-6">
        <div className="space-y-3 text-sm text-slate-700">
          <h2 className="text-base font-semibold tracking-tight text-slate-900">Role of teachers</h2>
          <p>
            Teachers guide candidates in selecting appropriate repertoire, planning technical work and preparing for the full range of examination components. They play a vital role in ensuring that candidates understand the expectations at each level and approach the examination with confidence.
          </p>
          <p>
            The board encourages teachers to use examination syllabi as one part of a broader musical education, integrating creative work, ensemble playing and listening activities as appropriate.
          </p>
        </div>
        <SideIllustration
          src={IMAGE_SOURCES.teachersLesson}
          alt="Music teacher working with students in an academic setting"
        />
      </section>

      <section className="grid gap-6 rounded-2xl border border-slate-200 bg-slate-50/80 p-5 shadow-sm backdrop-blur-xl md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] md:p-6">
        <div className="space-y-3 text-sm text-slate-700">
          <h2 className="text-base font-semibold tracking-tight text-slate-900">Benefits for educators</h2>
          <ul className="space-y-1">
            <li>• A clearly defined framework for planning individual lessons and long-term study.</li>
            <li>• External verification of student progress to share with families and institutions.</li>
            <li>• Access to assessment reports that support reflective teaching practice.</li>
            <li>• Opportunities to align teaching programmes with an internationally oriented certification system.</li>
          </ul>
        </div>
        <SideIllustration
          src={IMAGE_SOURCES.teachersSheetMusic}
          alt="Sheet music on a stand in a formal teaching environment"
        />
      </section>
    </div>
  );
}
